import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';

import { IKnmErknmFormInspector } from '../interfaces/IKnmErknmFormInspector';

export const getInspectorsErknmValidate = (
  inspectorsErknm: IKnmErknmFormInspector[] | undefined,
  isEditableInStatusCommentsExist: boolean | undefined,
  shouldValidationForGeneratedDecision?: boolean | undefined,
  isTypeCodeVP?: boolean,
): FormErrors<IKnmErknmFormInspector>[] | string | undefined => {
  if (
    isEditableInStatusCommentsExist &&
    shouldValidationForGeneratedDecision &&
    !inspectorsErknm?.length &&
    isTypeCodeVP
  ) {
    return 'Поле не может быть пустым';
  }

  return inspectorsErknm?.map(item => {
    return {
      fullName: makeRequired('Поле не может быть пустым')(item.fullName),
      position: makeRequired('Поле не может быть пустым')(item.position),
    };
  });
};
